import React from "react";
import Cable from "./Cable";
import Filters from "./Filters";
import Footer from "./Footer";

import cablelist from "../cablelist";

class App extends React.Component {

    constructor() {
        super();
        this.filterConnector = this.filterConnector.bind(this);
        this.openFilters = this.openFilters.bind(this);
    }
    
    state = {
        cables: {},
        filtersHidden: true,
        whichExtraFiltersEnabled: [],
       
    };

    mySelection = React.createRef();

    cablelist = cablelist;

    openFilters = () => {
        
        let filterStateCopy = this.state.filtersHidden;
        
        this.setState({ filtersHidden : !filterStateCopy });  
        
    }

    handleCheckboxes = (e) => {  
        
        //copy the array
        var extraFiltersCopy = this.state.whichExtraFiltersEnabled;

        if(extraFiltersCopy.length === 0 || (extraFiltersCopy.includes(e.target.name) === false) ) {
            extraFiltersCopy.push(e.target.name);
            console.log(e.target.name + ' added')
        } else {

            //if the extrafilters array already includes that name, remove it
            for(var i = 0; i < extraFiltersCopy.length; i++) { 
                if(extraFiltersCopy[i] === e.target.name) {
                    console.log(extraFiltersCopy[i] + ' removed');
                    extraFiltersCopy.splice(i, 1); 
                    break;

                } else { 
                    console.log("skipping over " + i)
                }
            }
        }

        this.setState({ whichExtraFiltersEnabled : extraFiltersCopy });
        this.filterConnector();

    }

    filterConnector = () => {       
       
        var selectedOption = this.mySelection.value.selectedOptions[0].value;

        console.log(selectedOption);
        
        const stateCopy = {...this.state.cables};
        
        // loop through all cables, if connectorType includes the selected option then set visible to true, else set to false.
        var countForSelected = 0;

        for (let key in stateCopy) {  
            
            if(selectedOption === "all") {
                stateCopy[key].visible = true;
                countForSelected += stateCopy[key].quantity;
            } else if(stateCopy[key].connectorType.toLowerCase().includes(selectedOption)) {
                countForSelected += stateCopy[key].quantity;
                stateCopy[key].visible = true;
            } else {
                stateCopy[key].visible = false;
            }
          }
        
        //now check which additional filters are present
        var extraFiltersCopy = this.state.whichExtraFiltersEnabled;

        //if the visible ones after filtration also match the extra filters, keep them visible. Otherwise, turn them off.
        for (let key in stateCopy) {  
            
           extraFiltersCopy.forEach( function(element) {
                if(stateCopy[key].visible === true) {

                    var checkForElement = function(myEl) {
                        // checks whether one of them is in the other array
                        console.log('running through the some loop, my extra filter is ' + element + ' and my connector size is ' + myEl);
                        return element.toLowerCase().includes(myEl);
                      };

                    if(stateCopy[key].connectorSize.some(checkForElement)) {
                        //if this is true then it's visible and also has my extra filter
                        console.log("it is true so then it is visible and also has my extra filter");
                    } else {
                        //turn it off and subtract from the number of results
                        stateCopy[key].visible = false;
                        countForSelected -= stateCopy[key].quantity;
                    }

                } else {
                 //else?   
                }            
            }
           );
            
        }

        // update the state...
        this.setState({ cables : stateCopy });
        this.setState({ countForSelected : countForSelected });
        this.setState({ selectedOption : selectedOption });
        this.setState({ whichExtraFiltersEnabled : extraFiltersCopy });
    }

    componentDidMount() {

        var initialQuantity = 0;

        // go through all the items from the cable list to see how many there are
       
        for (let key in this.cablelist) {             
            initialQuantity += cablelist[key].quantity;
        }

        // add the  whole list of cables to state of App
        this.setState({ cables: this.cablelist });

        // add the initial number of cables to the state of the App
        this.setState({ count: initialQuantity });
        this.setState({ countForSelected: initialQuantity });
        this.setState({ selectedOption : "all" });
       
    }



    render() {
        return ( 
           <div className="app">

            <h1>Cable<br />Wrangler</h1>
            
            <div className="whereTheDropdownsGo">


            <label htmlFor="connectorSelect">Filter by connector... </label>

                <select id="connectorSelect" ref={this.mySelection} onChange={this.filterConnector}>
                    <option value="all">Connector Type (All)</option>
                    <option value="usb">USB</option>
                    <option value="lightning">Lightning</option>
                    <option value="hdmi">HDMI</option>
                    <option value="trs">TRS/TRRS</option>
                    <option value="rca">RCA</option>
                    <option value="ethernet">Ethernet</option>
                    <option value="firewire">Firewire</option>
                    <option value="vga">VGA</option>
                    <option value="dvi">DVI</option>
                    <option value="sata">SATA</option>
                    <option value="apple 30-pin">Apple 30-pin</option>
                </select>

                <button id="additional-filters-button" onClick={this.openFilters}>
                
                <svg width="111px" height="80px" viewBox="0 0 111 80" version="1.1" >
    
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
                    <g id="Group" transform="translate(2.000000, 6.000000)" fillRule="nonzero">
                    <path d="M0.5,8.5 L106.136719,8.5" id="Line" stroke="#000000" strokeWidth="5"></path>
                    <path d="M0.5,33.7807536 L106.136719,33.7807536" id="Line-Copy" stroke="#000000" strokeWidth="5"></path>
                    <path d="M0.5,59.0603093 L106.136719,59.0603093" id="Line-Copy-2" stroke="#000000" strokeWidth="5"></path>
                    <circle id="Oval" stroke="#FFFFFF" strokeWidth="6" fill="#000000" cx="89.676059" cy="8.5" r="11.5"></circle>
                    <circle id="Oval-Copy" stroke="#FFFFFF" strokeWidth="6" fill="#000000" cx="64" cy="33.7807536" r="11.5"></circle>
                    <circle id="Oval-Copy-2" stroke="#FFFFFF" strokeWidth="6" fill="#000000" cx="34.4477044" cy="59.0603093" r="11.5"></circle>
                        </g>
                </g>
                </svg>
                
                <span>Refine ({this.state.whichExtraFiltersEnabled.length})</span>
                
                </button>

                {/* <button>Show Graph</button> */}


            </div>

            

                <Filters isHidden={this.state.filtersHidden} parentMethod={this.handleCheckboxes}  />

                <div className="readout">
                  
                    <p>{this.state.countForSelected} 
                    
                    
                     {this.state.countForSelected === 1 ? ' item ' : ' items '}
                   
                     {this.state.countForSelected === 1 ? ' matches ' : ' match '}
        
                    
                    <span className="taglike">{this.state.selectedOption}</span>
                    
                    {this.state.whichExtraFiltersEnabled.length > 0 &&
                        <span> refined by: </span>
                    }

{this.state.whichExtraFiltersEnabled.map( (aFilter) => <span key={aFilter.toString()} className="taglike">{aFilter}</span>)}

</p>
{this.state.countForSelected === 0 &&
                        <p>Try removing filters.</p>
                    }

                  
                    
                </div>

                <div className="gridWrap">   
                    {Object.keys(this.state.cables).map(key => <Cable key={key} details={this.state.cables[key]} />)}
                </div>

                <Footer />
               
            </div>
           
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js